
export function getActiveAccordion(activeAccordions: any[], value: string) {
    return activeAccordions.find(item => item === value);
}
